import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    personalTags: {
        url: `${customerApi}/api/tags`,
        type: 'GET',
    },
    corpTags: {
        url: `${customerApi}/api/corp_tags`,
        type: 'GET',
    },
    tag: {
        url: `${customerApi}/api/corp_tags/mark`,
        type: 'POST',
    },
}
